export default {"src":"/_next/static/media/career-management.5339021d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};